export default __webpack_public_path__ + "static/media/not_allowed.f7e2d9de.svg";